import React, { useState, createRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import { TEMPLATE_TYPE } from 'constants/common';
import ExpertReportSection from './ExpertReportSection';

const ExpertReport = ({
  t, setDownloadReportModalVisible, report, setGalleryContent, setTooltipPosition,
}) => {
  const [basicFunctionalityTestsDisputeVisible, setBasicFunctionalityTestsDisputeVisible] = useState(true);
  const [generalDisputeVisible, setGeneralDisputeVisible] = useState(true);
  const [expertiseTermsDisputeVisible, setExpertiseTermsDisputeVisible] = useState(true);

  const contentsGroupedByCategoryName = _.groupBy(report.contents, 'question.category.name');

  const categoryRefs = Object.keys(contentsGroupedByCategoryName).reduce((acc, categoryName) => {
    acc[categoryName] = createRef();
    return acc;
  }, {});

  const scrollToCategory = (categoryName) => {
    categoryRefs[categoryName].current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  return (
    <div className="im-box im-box--white im-box--border-radius im-box--list-item im-box--padding-sm-15 mb-3 mb-lg-0">

      <div className="row mb-3">
        <div className="col-15 col-sm">
          <div className="row align-items-center mb-2">
            <div className="col-15 col-md-auto mb-1 mb-md-0">
              <h2 className="fs-21 fw-900">{t('expertReport')}</h2>
            </div>
            <div className="col-15 col-md pl-md-0 align-items-center">
              <svg className="wh-15 inline-block ml-md-1 mr-1">
                <use xlinkHref="/image/icons.svg#ic-safemark" />
              </svg>
              <span className="fs-12 fw-700">{t('underTheGuaranteeOfIyiMakina')}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span className="fs-12">{t('underTheGuaranteeOfIyiMakinaAlert')}</span>
            </div>
          </div>
        </div>
        {report.pdf && (
          <div className="col-15 col-sm-auto" onClick={() => setDownloadReportModalVisible(true)}>
            <a data-toggle="modal" className="im-button im-button--outline-black w-100 justify-content-center mt-3 mt-sm-0">
              <div className="im-button__icon im-button__icon--left">
                <i className="fa-solid fa-download" />
              </div>
              <span>{t('downloadPDF')}</span>
            </a>
          </div>
        )}
      </div>

      {report.template.type === TEMPLATE_TYPE.DETAIL
        && (
          <div className="row py-4 d-none d-lg-flex">
            {_.map(Object.keys(contentsGroupedByCategoryName), (categoryName, index) => (
              <div
                className="col-5 list-item-v"
                key={index}
                onClick={() => scrollToCategory(categoryName)}
              >
                <a className="fs-13 fw-700 hover-to-yellow">
                  {categoryName}
                </a>
              </div>
            ))}
          </div>
        )}

      {/* REPORTS */}
      {report.template.type === TEMPLATE_TYPE.DETAIL && (
        <div className="row d-none d-lg-flex">
          <div className="col-15">
            <div className="separator separator--horizontal separator--neg-margin-15" />
          </div>
        </div>
      )}

      {report.template.type === TEMPLATE_TYPE.DETAIL
        && _.map(Object.keys(contentsGroupedByCategoryName), (categoryName, index) => (
          <ExpertReportSection
            categoryContents={contentsGroupedByCategoryName[categoryName]}
            key={index}
            ref={categoryRefs[categoryName]}
            setGalleryContent={setGalleryContent}
            setTooltipPosition={setTooltipPosition}
          />
        ))}

      <div className="row mt-3">
        <div className="col">
          <div className={`im-accordion im-accordion--type2 im-accordion--rotate-icon mt-2 ${basicFunctionalityTestsDisputeVisible ? 'im-accordion--active' : ''}`}>
            <div className="im-accordion__head" onClick={() => setBasicFunctionalityTestsDisputeVisible((val) => !val)}>
              <h3 className="im-accordion__head__title">Temel Fonksiyon Testleri</h3>
              <div className="im-accordion__head__toggle-icon d-lg-none">
                <i className="fa-solid fa-angle-down" />
              </div>
            </div>
            <div className="im-accordion__body" style={{ lineHeight: '1.3' }}>
              Ekipman yüklüyken ya da bütün viteslerde ayrı ayrı testleri yapılmamıştır. Ekipmanın üreticinin belirlediği şartlar dahilinde çalıştığına dair hiçbir beyanda bulunulmamış ve garanti verilmemiştir.
              Burada açıkça belirtilenler dışında başka bir makinanın fonksiyonuyla ilgili hiçbir inceleme yapılmamıştır.
              Makinaya ait alt takım bileşenleri için yalnızca raporda belirtilen fotoğraflar sağlanmıştır ve bu fotoğraflar makinaya ait tüm alt takımın durumunu bir bütün olarak yansıtmayabilir.
            </div>
          </div>
          <div className={`im-accordion im-accordion--type2 im-accordion--rotate-icon mt-2 mt-lg-4 ${generalDisputeVisible ? 'im-accordion--active' : ''}`}>
            <div className="im-accordion__head" onClick={() => setGeneralDisputeVisible((val) => !val)}>
              <h3 className="im-accordion__head__title">Genel</h3>
              <div className="im-accordion__head__toggle-icon d-lg-none">
                <i className="fa-solid fa-angle-down" />
              </div>
            </div>
            <div className="im-accordion__body" style={{ lineHeight: '1.3' }}>
              Ayrıntılı ekipman bilgileri sınırlı kapsamdadır ve iyiMakina, ekipmanın açıkça belirtilenler dışında herhangi bir özelliğini veya bileşenini incelememiştir.
              Fakat açıkça belirtilmezse, açıklanan veya kastedilen bu makinanın tüm aletleri veya parçaları dahil olmak üzere, fonksiyonları, işlevsellikleri ve güvenlik standartları hakkında açık veya zımni hiçbir beyan veya garanti vermemektedir.
              Özellikle teklif vermeden önce ekipmanın raporunun incelenmesi şiddetle tavsiye edilir.
            </div>
          </div>
          <div className={`im-accordion im-accordion--type2 im-accordion--rotate-icon mt-2 mt-lg-4 ${expertiseTermsDisputeVisible ? 'im-accordion--active' : ''}`}>
            <div className="im-accordion__head" onClick={() => setExpertiseTermsDisputeVisible((val) => !val)}>
              <h3 className="im-accordion__head__title">Ekspertiz Koşulları</h3>
              <div className="im-accordion__head__toggle-icon d-lg-none">
                <i className="fa-solid fa-angle-down" />
              </div>
            </div>
            <div className="im-accordion__body" style={{ lineHeight: '1.3' }}>
              iyiMakina incelemeleri, ekipmanın ana sistemlerini ve diğer kısımlarının görünür durumunu, denetimin yapıldığı gün geçerli olmak kaydıyla sunduğunu ve ekspertiz raporunun yük veya kazma/kaldırma testi içermediğini hatırlatmaktadır.
              Ekspertiz incelemeleri; ekipmanın gizli kusurlarını veya yalnızca cihazla bağlantılı olarak bulunabilecek koşulların tespit edilmesi, fiziksel olarak sökülmesi veya söküm tekniklerinin kullanılması düşünülerek yapılmamış/amaçlanmamıştır.
              Bu inceleme raporu, makinaların çeşitli bileşenlerinin değerlendirmelerini, yorumlarını ve fotoğraflarını içerir. Tüm alıcıların, en iyi teklif ve satın alma kararını verebilmek için, fotoğraflar da dahil olmak üzere ekspertiz raporundaki mevcut tüm bilgileri dikkatle incelemeleri beklenir.
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

ExpertReport.propTypes = {
  t: PropTypes.func,
  setDownloadReportModalVisible: PropTypes.func,
  report: PropTypes.object,
  setGalleryContent: PropTypes.func,
  setTooltipPosition: PropTypes.func,
};

export default withTranslation('common')(ExpertReport);
